import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, IdDescription, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import {
  ProductionProcessesForSupplier,
  ProductionProcessSupplier,
  UpdateProductionProcessesSupplier,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductionProcessSupplierService extends TmsWebBaseEditCreateService<
  ProductionProcessSupplier,
  ProductionProcessSupplier
> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('ProductionProcessSupplier', $localize`Production Process Supplier`, httpService, notificationService);
  }

  getForSupplier(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForSupplier/${id}`);
  }

  getProductionProcessesForSupplier(id: string): Observable<ProductionProcessSupplier[]> {
    return this.httpService.get<ProductionProcessSupplier[]>(`${this.apiUrl}/Supplier/${id}`);
  }

  getSuppliersForProductionProcess(id: string): Observable<ProductionProcessSupplier[]> {
    return this.httpService.get<ProductionProcessSupplier[]>(`${this.apiUrl}/ProductionProcess/${id}`);
  }

  getAllProductionProcessesForSupplier(supplierId: string): Observable<ProductionProcessesForSupplier[]> {
    return this.httpService.get<ProductionProcessesForSupplier[]>(
      `${this.apiUrl}/GetAllProductionProcesses/${supplierId}`,
    );
  }

  getAllSuppliersForProductionProcess(productionProcessId: string): Observable<ProductionProcessesForSupplier[]> {
    return this.httpService.get<ProductionProcessesForSupplier[]>(
      `${this.apiUrl}/GetAllSuppliers/${productionProcessId}`,
    );
  }

  updateProductionProcessSuppliers(
    supplierId: string,
    productionProcesses: UpdateProductionProcessesSupplier[],
  ): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateProductionProcessSuppliers`, {
      supplierId,
      productionProcesses,
    });
  }

  updateSupplierProductionProcesses(productionProcessId: string, supplierIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateSupplierProductionProcesses`, {
      productionProcessId,
      supplierIds,
    });
  }
}
